jQuery( document ).ready(function( $ ) {

  // Photo Gallery Block
  if ($('.photo-gallery').length > 0 ) {

    $('.photo-gallery__slides').slick({
      autoplay: true,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      appendDots: $('.append-dots'),
    });
  }

  // Quote Slider Block
  if ($('.quote-slider').length > 0 ) {

    $('.quote-slider__slides').slick({
      autoplay: true,
      dots: true,
      speed: 500,
      slidesToShow: 1,
      prevArrow: $('.prev-quote'),
      nextArrow: $('.next-quote'),
      appendDots: $('.append-dots-quote'),
    });
  }

  // video slider block
  if ($('.video-slider').length > 0 ) {


    $('.video-slider').each(function(index, element) {
      var $sliderBox = $(element).find('.video-slider__slides'),
          $sliderControls = $sliderBox.next('.append-dots-video');
      var $dots = $(this).find('.append-dots-video');

      $sliderBox.slick({
        autoplay: true,
        dots: true,
        speed: 500,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        appendDots: $dots,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  // Mobile Nav
  // Mobile toggle
  $( '.navbar-burger' ).click(function(){
    $('.open').toggle();
    // Let's hide the donate button as it gets in the way of the nav
    $('#XAKWTADP').toggle();
    $('.a11y-non-responsive.a11y-toolbar').toggle();
    // purchase form not playing nicely with menu. Let's hide it
    $("#nf-form-4-cont").toggle();
    //$('#header-width').toggleClass('black-main-nav');
    // $('body').toggleClass('fixed');
    // $('.navbar-burger').toggleClass('burger-background');
    $('.closed').toggle();
    $('#mobile-menu').slideToggle(500);
    if ($('.open').is(':visible')) {
      $('body').css('overflow', 'auto');
    }
    else {
      $('body').css('overflow', 'hidden');
    }
  });

  if ($(".menu-toggle").length > 0) {
    $(".menu-toggle").click(function(){
      $(this).closest('li').find('.menu-level-2').slideToggle();
      $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
    })
  }

  if ($(".menu-toggle-2").length > 0) {
    $(".menu-toggle-2").click(function(){
      $(this).closest('li').find('.menu-level-3').slideToggle();
      $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
    })
  }

  if ($(".menu-toggle-3").length > 0) {
    $(".menu-toggle-3").click(function(){
      $(this).closest('li').find('.menu-level-4').slideToggle();
      $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
    })
  }

  if ($(".menu-toggle-4").length > 0) {
    $(".menu-toggle-4").click(function(){
      $(this).closest('li').find('.menu-level-5').slideToggle();
      $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
    })
  }

  // nasty hack to remove empty ul tags in menu for accessibility
  $('#nav-upper ul').not(':has(li)').remove();

  // Accordion block
  if ($('.faq__question').length > 0) {
    $('.faq__question').click(function(event){
      event.preventDefault();
      $(this).siblings('.faq__answer').slideToggle();
      $(this).find('.icon__closed').toggle();
      $(this).find('.icon__open').toggle();
    });

    // Open if id is in url
    var current = window.location.hash;

    if (current.length > 0) {
      $(current).trigger('click');

    }
  }

  // Toggle High Contrast site improve fix
  if ($('#is_normal_contrast').length > 0) {
    $('#is_normal_contrast').attr('title', 'Toggle High Contrast');
  }

  // Toggle Font size site improve fix
  if ($('#is_normal_fontsize').length > 0) {
    $('#is_normal_fontsize').attr('title', 'Toggle Font size');
  }

  // Bio block
  if ($('.bio-block').length > 0) {
    $('.bio-title').click(function(event){
      event.preventDefault();
      $(this).siblings('.summary-short').toggle();
      $(this).siblings('.summary-long').slideToggle();
      $(this).find('.icon__closed').toggle();
      $(this).find('.icon__open').toggle();
    });
  }

  // scroll top
  $("#scroll_top").click(function(){
    $(window).scrollTop(0);
  });

  // Accessibility spacebar
  $('.menu-pop-up').on('keypress', function (event) {

    if (event.code === 'Space') {
      event.preventDefault();

      $('.dropdown-content').each(function() {
        $(this).css('visibility','hidden');
      })

      let background = $(this).siblings('.dropdown-content:first');
      if (background.css('visibility') == 'hidden') {
        background.css('visibility','visible');
      }
    }

    // Close dropdowns on escape
    if (event.code === 'Escape') {
      event.preventDefault();
      $('.dropdown-content').each(function() {
        $(this).css('visibility','hidden');
      })
    }

  });

  // Close all dropdowns on escape
  $(document).on(
      'keydown', function(event) {
        var lastColor = '';
        $("a, input, button").focusin(function(){
          if ($(this).prop("nodeName") == 'A' && $(this).css("color").replace(/\s/g, '').toLowerCase() == 'rgb(255,255,255)')
          {
            lastColor = $(this).css("color");
            $(this).css({'background-color':'#f9de4b', 'color':'#000000', 'display':'inline-block', 'text-decoration':'underline'});
            $(this).find('path').css({'stroke':'#000'});
          }
          else{
            if($('.thumbnail-image-item').is(':focus')){
              $(this).css({'text-decoration':'underline', 'display':'inline-block' ,'border':'5px solid black'});
            }else if($('.video-listing-item').is(':focus')){
              $(this).css({'background-color':'#f9de4b', 'text-decoration':'underline'});
            }else{
              $(this).css({'background-color':'#f9de4b', 'display':'inline-block' ,'text-decoration':'underline'});
            }
          }    
        });
        
        $("a, input, button").focusout(function(){
          if (lastColor != ''){
            $(this).css({'background-color':'', 'display':'','text-decoration':'none', 'color': lastColor});
            $(this).find('path').css({'stroke':lastColor});
            lastColor = '';
          }
          else{
            $(this).css({'background-color':'', 'display':'','text-decoration':'none'});
          }                  
        });

        $(".thumbnail-image-item").focusout(function(){
          $(this).css({'background-color':'', 'display':'','text-decoration':'none', 'border':'5px solid transparent'});              
        });
        
        if (event.key == "Escape") {
          $('.dropdown-content').each(function() {
            $(this).css('visibility','hidden');
          })
        }
      });

  $('.print-page').click(function(){
    $('#XAKWTADP').hide();
    $('.grecaptcha-badge').hide();
  });

  window.onafterprint = function(event) {
    $('.grecaptcha-badge').show();
};

  // Tabs
  $('.tab').click(function(e){
    e.preventDefault();
    var container = $(this).closest("div[id]").attr('id');

    var tab_id = $(this).data("id");
    $('#'+container+' .tab').each(function(index, element) {
      $(element).css('background', '#ffffff');
    });
    $(this).css('background', '#DBD5C7');
    $('#'+container+' .tab-content').each(function(index, element) {
      $(element).hide();
    });
    $('#'+container+' .tab-'+tab_id).fadeIn();

  });

  if($('.video-tab').length > 0){
  
    // Video tabs
    $('.video-tab').click (function (e) {
      e.preventDefault();

      var slug = $(this).data("id");

      loadTab(slug, $(this));
    });


    if(window.location.hash != '' && window.location.hash.startsWith('#tab_')) {
      var slug = window.location.hash.replace('#tab_', '');

      var el = $('[data-id="'+slug+'"]');

      if(el.length > 0){
        loadTab(slug, el);
      }      
    }


    function loadTab(slug, focus_tab){
      var taxonomy = $('.taxonomy').data();

      history.replaceState("null","null", "#tab_" + slug);

      $.ajax ({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'JSON',
        data: {
          action: 'get_videos_ajax',
          slug : slug,
          taxonomy : taxonomy
        },
        success: function (response) {
          // render the html
          $('.video-content-wrapper').html(response.data).fadeIn;

          // reset the tabs
          $('.video-tab').each(function(index, element) {
            $(element).css('background', '#ffffff');
          });
          focus_tab.css('background', '#DBD5C7');
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // this error case means that the ajax call, itself, failed, e.g., a syntax error
          // in your_function()
          alert ('Request failed: ' + thrownError.message) ;
        },
      }) ;
    }

  }

  //SiteImprove check for iFrame elements that don't have alt text
  $('iframe').each(function () {
      var attr = $(this).attr('title');
      var aria = $(this).attr('aria-label');

      if (typeof attr === 'undefined' && attr !== false && typeof aria === 'undefined' && aria !== false) {
          var src = $(this).attr('src').toLowerCase();
          var new_title = 'iFrame container for external source';
          
          //known sources
          if(src.indexOf('youtube') > 0){
            new_title = 'Youtube video Player';
          }
          else if (src.indexOf('vimeo') > 0) {
            new_title = 'Vimeo video Player';
          }
          else if (src.indexOf('soundcloud') > 0) {
            new_title = 'SoundCloud Player';
          }

          $(this).attr('title', new_title);
      }
      const rendia = 'Rendia Embed Player';
      if(attr === rendia && aria === rendia){
        const number = Math.floor(Math.random()*100);
        $(this).attr('title', `${rendia} ${ number }`);
        $(this).attr('aria-label', `${rendia} ${ number }`);
      }
  });

  //SiteImprove check for offscreen and set aria-label
  $('.offscreen, .if-js-enabled').each(function () {
    var aria = $(this).attr('aria-label');
    if (typeof aria === 'undefined' && aria !== false) {
      var text = $(this).text();
      $(this).attr('aria-label', text);
      $(this).attr('role', 'region');
    }
  });

});
